import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRightIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { AuthContext } from "../context/AuthContext";

/**
 * Sticky reminder banner shown when the user hasn't finished the welcome
 * wizard. Replaces the previous hard redirect from ProtectedRoute — users
 * can now browse the app freely while a single visible nudge keeps the
 * setup flow one click away.
 */
const OnboardingBanner = () => {
  const { profile, isAuthenticated } = useContext(AuthContext);
  const location = useLocation();
  // Track per-session dismiss so the banner doesn't bug a user who's
  // ignoring it on this visit. Comes back next session.
  const [dismissed, setDismissed] = useState(false);

  if (!isAuthenticated || !profile) return null;
  if (profile.onboarding_completed) return null;
  if (dismissed) return null;
  // Don't double up on /welcome itself.
  if (location.pathname.startsWith("/welcome")) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[min(92vw,560px)]">
      <div className="flex items-center gap-3 px-4 py-3 rounded-2xl bg-gradient-to-r from-indigo-600 to-emerald-600 text-white shadow-2xl border border-white/10">
        <div className="flex-1 min-w-0">
          <p className="font-bold text-sm">Finish setup to unlock the Council</p>
          <p className="text-[11px] text-white/80 mt-0.5 truncate">
            Tell us your jurisdiction, risk profile and goals — every answer
            you get gets meaningfully better.
          </p>
        </div>
        <Link
          to="/welcome"
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-white/15 hover:bg-white/25 text-white text-xs font-bold whitespace-nowrap"
        >
          Finish
          <ArrowRightIcon className="w-3 h-3" />
        </Link>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="text-white/70 hover:text-white"
          aria-label="Dismiss"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default OnboardingBanner;
